/* Cómo se llama esto.
 *
 * En un solo lugar porque un nombre repetido en veinte archivos se escribe de
 * tres formas distintas antes de fin de mes: FiBOT, Fibot, FIBOT. Acá hay una
 * sola forma y no hay dónde equivocarse.
 *
 * LA FORMA ES "FiBOT": efe minúscula, i minúscula, BOT en mayúsculas. Igual que
 * en fibot.ar, en FiBOT-Peajes y en la organización de Supabase.
 *
 * El patrón "marca · descriptor" no lo inventamos acá: viene de
 * "FiBOT · Conciliación de Peajes", que ya estaba en uso. Esto lo continúa.
 *
 * OJO: manifest.json e index.html son archivos estáticos y no pueden importar
 * esto. Si el nombre cambia, hay que tocarlos a mano — están al lado, en
 * front/public/.
 */

export const MARCA = "FiBOT";

export const MARCA_LARGA = "FiBOT · Gestión de Flotas";

/* La empresa, que no es lo mismo que el producto. FiBOT es la marca de esto;
 * Cantarini es de quién es la flota. Separarlos importa el día que FiBOT corra
 * en otro lado. */
export const EMPRESA = "Transportes Cantarini";
